import i18next from 'i18next';

import { initI18next } from '@growtherapy/i18n';
import { NS_SPROUT_CORE } from '@growtherapy/sprout-ui';

import { NS_SEEDLINGS_CORE } from '@grow-therapy-team/seedling-components';

import { NS_TELEHEALTH_CORE, telehealthCoreResoucesEn } from '.';
import { logger } from '../datadog/logger';
import { getStoredLanguagePreference } from './languagePreference';
import { ADDITIONAL_SUPPORTED_LOCALES } from './locales';

export const CROWDIN_DISTRIBUTION_HASH = 'e-55b8f1847490f0b920ba3b3mgk';

export const initI18n = (): void => {
  initI18next(i18next, {
    lng: getStoredLanguagePreference(),
    ns: [NS_TELEHEALTH_CORE, NS_SPROUT_CORE, NS_SEEDLINGS_CORE],
    defaultNS: [NS_TELEHEALTH_CORE, NS_SPROUT_CORE, NS_SEEDLINGS_CORE],
    resources: telehealthCoreResoucesEn,
    additionalSupportedLngs: ADDITIONAL_SUPPORTED_LOCALES,
    otaOptions: {
      distributionHash: CROWDIN_DISTRIBUTION_HASH,
      otaLanguages: ADDITIONAL_SUPPORTED_LOCALES,
    },
    missingKeyHandler: (lngs, ns, key) => {
      logger.error(`[i18n] Missing translation key: ${key} ns: ${ns} lng: ${lngs} service: telehealth`);
    },
  });
};
